// extracted by mini-css-extract-plugin
export default {"container":"on-off-switch_container__in158","base":"on-off-switch_base__0ABBs","base-active":"on-off-switch_base-active__AXUdS","knob":"on-off-switch_knob__ewFCt"};